export const SEGMENT_COLORS = [
  "#1890ff",
  "#52c41a",
  "#faad14",
  "#f5222d",
  "#722ed1",
  "#13c2c2",
  "#eb2f96",
]

export const handlesToPercentages = (handles: number[], count: number): number[] => {
  if (count === 1) return [100]

  const sorted = [...handles].sort((a, b) => a - b)
  const segments: number[] = []
  let prev = 0
  for (const h of sorted) {
    segments.push(h - prev)
    prev = h
  }
  segments.push(100 - prev)

  const result: number[] = []
  let total = 0
  for (let i = 0; i < segments.length; i++) {
    if (i === segments.length - 1) {
      result.push(100 - total)
    } else {
      const rounded = Math.round(segments[i])
      result.push(rounded)
      total += rounded
    }
  }

  return result
}

export const evenHandles = (count: number): number[] => {
  if (count < 1) return []

  return Array.from({ length: count }, (_, i) => Math.round((i * 100) / count)).slice(1)
}

export const cutoffsToHandles = (cutoffs: number[]): number[] => cutoffs.slice(0, -1).map(c => Math.round(c * 100))
